import React, {useMemo} from 'react';
import GoogleMap from "../../contexts/WorldMapContext/GoogleMap";
import {colors, ProductionAreaPolyline, SeaWayPolyline} from "../../contexts/WorldMapContext/Polyline";
import {useRouteUpgrade} from "./RouteUpgradeContext";
import {markerByName, PointMarker} from "../../contexts/WorldMapContext/Marker";

const ProAreas = () => {
    const [{data}] = useRouteUpgrade(state => state.proAreas);
    return <>
        {data.map((item: any) => <ProductionAreaPolyline
            key={item.id}
            data={item}
            show={true}
        />)}
    </>
}

const Locations = () => {
    const [locations] = useRouteUpgrade(state => state.locations);
    return <>
        {locations.map(item => {
            const Marker = markerByName[item.type];
            if (Marker) {
                return <Marker key={item.id} data={item}/>
            }
            return null
        })}
    </>
}

const Seaway = () => {
    const [points] = useRouteUpgrade(state => state.points);
    const [onlySeaway] = useRouteUpgrade(state => state.onlySeaway);
    const color = colors[0];
    const seaway = useMemo(() => points.map((item, subI) => ({
        id: subI,
        name: `${subI}`,
        color,
        lat: item.latitude,
        lng: item.longitude,
    })), [points, color]);

    return <>
        <SeaWayPolyline
            key={1}
            data={{points: seaway}}
            show={true}
            width={3}
            color={color}
        />
        {!onlySeaway && <>
            {seaway.map((point, i) => (i && (i < seaway.length - 1)) ? <PointMarker
                key={point.id}
                data={point}
                show={true}
            /> : null)}
        </>}
    </>
}

interface IProps {
}

const Map: React.FC<IProps> = () => {
    return <div className='h-full w-full'>
        <GoogleMap>
            <ProAreas/>
            <Locations/>
            <Seaway/>
        </GoogleMap>
    </div>;
};

export default Map;
